export default __webpack_public_path__ + "static/leanGuidesBanner-aa7a4eca03fb9504e1f1060da732f88f.jpeg";